export default __webpack_public_path__ + "static/media/grayman3.8fa49cf1.jpeg";